/*
 * Paleta compartilhada pelos módulos auxiliares (BM-2 e, na sequência da
 * ordem de construção, SDB/SDV-V2/MBR-V2/SDG/SPS — ver
 * docs/specs/cma-modulos-auxiliares-3d.md, §4 e §6.1). Um lugar só para as
 * cores de carcaça/terminais/LEDs, para os próximos módulos da mesma família
 * reaproveitarem em vez de redefinir hex por arquivo.
 */
import * as THREE from 'three';
import { srgbColor } from '../geometriaHelpers';

export const LED_VERDE = 0x49b36e;
export const LED_AMBAR = 0xf9a825;
export const LED_VERMELHO = 0xd93a3a;

/**
 * LEDs nascem no estado de repouso — só o "Status" aceso (equipamento
 * ligado, sem alarme), o resto apagado/dim. É a leitura mais neutra para um
 * ativo sem alarme ativo; ver §7.5 da spec (ponto em aberto) se o pedido for
 * copiar os LEDs acesos das imagens de referência.
 */
export function criarMateriaisPaineis() {
  return {
    corpo: new THREE.MeshStandardMaterial({
      color: srgbColor(0x1c1d1f), roughness: 0.55, metalness: 0,
    }),
    moldura: new THREE.MeshStandardMaterial({
      color: srgbColor(0x27282a), roughness: 0.55, metalness: 0,
    }),
    painel: new THREE.MeshStandardMaterial({
      color: srgbColor(0x6a6d70), roughness: 0.78, metalness: 0,
    }),
    terminal: new THREE.MeshStandardMaterial({
      color: srgbColor(0x2e8b3d), roughness: 0.6, metalness: 0.05,
    }),
    pino: new THREE.MeshStandardMaterial({
      color: srgbColor(0x8a8d90), roughness: 0.4, metalness: 0.6,
    }),
    parafuso: new THREE.MeshStandardMaterial({
      color: srgbColor(0x8a8d90), roughness: 0.35, metalness: 0.7,
    }),
    conector: new THREE.MeshStandardMaterial({
      color: srgbColor(0x9aa0a3), roughness: 0.5, metalness: 0.2,
    }),
    botao: new THREE.MeshStandardMaterial({
      color: srgbColor(0x101112), roughness: 0.5, metalness: 0.1,
    }),
    ledVerdeAceso: new THREE.MeshStandardMaterial({
      color: srgbColor(LED_VERDE),
      emissive: srgbColor(LED_VERDE),
      emissiveIntensity: 0.9,
      roughness: 0.3,
    }),
    ledAmbarApagado: new THREE.MeshStandardMaterial({
      color: srgbColor(0x4a3a16),
      emissive: srgbColor(LED_AMBAR),
      emissiveIntensity: 0.05,
      roughness: 0.5,
    }),
    ledVermelhoApagado: new THREE.MeshStandardMaterial({
      color: srgbColor(0x3d1414),
      emissive: srgbColor(LED_VERMELHO),
      emissiveIntensity: 0.05,
      roughness: 0.5,
    }),
  };
}
